import { createMuiTheme } from "@material-ui/core/styles";
import { primaryColor, secondaryColor } from "./constants";

const theme = createMuiTheme({
  typography: {
    fontFamily: "Lato",
  },
  palette: {
    type: "light",
    primary: { main: primaryColor },
    secondary: { main: secondaryColor }, // This is just green.A700 as hex.
    text: {
      primary: "#4e4e4e",
      secondary: "#000000",
      ternary: "#7e7e7e",
    },
  },
  box: {
    // boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.1)",
    borderRadius: "5px",
    border: "1px solid #e0e0e0",
    padding: "5px 10px",
  },
  uncontrolledText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  halfHeight: {
    height: "50%",
    maxHeight: "50%",
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1440,
      xxl: 1920,
      xxxl: 2560,
    },
  },
});

export default theme;
